/**
 * Created on 2017-06-28.
 */

// node_modules
const crypto = require("crypto");

// modules
const number = require("../numbers-helper");

// properties
const VERSION = '1.0.0';
const NAME = 'crypto-utils-encryption';

const IV_LENGTH = 16; // For AES, this is always 16
const ALGORITHM = 'aes-256-cbc';
const SEPARATOR = ':';


const StringAlgorithm = {
    hex: 'hex',
    base64: 'base64',
};
const StringAlgorithms = Object.keys(StringAlgorithm);
const DEFAULT_STRING_ALGORITHM = StringAlgorithm.hex;

// methods

/**
 *
 * @param {string} text
 * @param {string} encryptionKey Must be 256 bytes (32 characters)
 * @param {string} stringAlgorithm can be hex or base64
 * @return {string}
 */
function encrypt(text, encryptionKey, stringAlgorithm) {
    stringAlgorithm = stringAlgorithm || DEFAULT_STRING_ALGORITHM;
    if (StringAlgorithms.indexOf(stringAlgorithm) === -1) {
        throw new Error("Only " + StringAlgorithms.join(", ") + " are allowed.");
    }

    let iv = crypto.randomBytes(IV_LENGTH);
    let cipher = crypto.createCipheriv(ALGORITHM, Buffer.from(encryptionKey), iv);
    let encrypted = cipher.update(text);

    encrypted = Buffer.concat([encrypted, cipher.final()]);

    return iv.toString(stringAlgorithm) + SEPARATOR + encrypted.toString(stringAlgorithm);
}

/**
 *
 * @param {string} text
 * @param {string} encryptionKey Must be 256 bytes (32 characters)
 * @param {string} stringAlgorithm can be hex or base64
 * @return {string}
 */
function decrypt(text, encryptionKey, stringAlgorithm) {
    stringAlgorithm = stringAlgorithm || DEFAULT_STRING_ALGORITHM;
    if (StringAlgorithms.indexOf(stringAlgorithm) === -1) {
        throw new Error("Only " + StringAlgorithms.join(", ") + " are allowed.");
    }

    let textParts = text.split(SEPARATOR);
    let iv = Buffer.from(textParts.shift(), stringAlgorithm);
    let encryptedText = Buffer.from(textParts.join(SEPARATOR), stringAlgorithm);
    let decipher = crypto.createDecipheriv(ALGORITHM, Buffer.from(encryptionKey), iv);
    let decrypted = decipher.update(encryptedText);

    decrypted = Buffer.concat([decrypted, decipher.final()]);

    return decrypted.toString();
}

/**
 *
 * @param text
 * @param keys
 * @param stringAlgorithm
 * @return {{key: string, text: string, stringAlgorithm: (*|string)}}
 */
function encryptWithKeys(text, keys, stringAlgorithm) {
    stringAlgorithm = stringAlgorithm || DEFAULT_STRING_ALGORITHM;
    if (StringAlgorithms.indexOf(stringAlgorithm) === -1) {
        throw new Error("Only " + StringAlgorithms.join(", ") + " are allowed.");
    }

    // console.log(NAME, "keys", keys);
    const keysArray = Object.keys(keys);
    // console.log(NAME, "keysArray", keysArray);

    const randomKeyIndex = number.randomInt(0, keysArray.length - 1);
    // console.log(NAME, "randomKeyIndex", randomKeyIndex);

    const keyName = keysArray[randomKeyIndex];
    const key = keys[keyName];

    const encrypted = encrypt(text, key, stringAlgorithm);

    return {
        key: keyName,
        text: encrypted,
        stringAlgorithm: stringAlgorithm,
    }
}

/**
 *
 * @param text
 * @param keys
 * @param keyName
 * @param stringAlgorithm
 * @return {{key: *, text: string, stringAlgorithm: (*|string)}}
 */
function decryptWithKeys(text, keys, keyName, stringAlgorithm) {
    stringAlgorithm = stringAlgorithm || DEFAULT_STRING_ALGORITHM;
    if (StringAlgorithms.indexOf(stringAlgorithm) === -1) {
        throw new Error("Only " + StringAlgorithms.join(", ") + " are allowed.");
    }

    const key = keys[keyName];

    const decrypted = decrypt(text, key, stringAlgorithm);

    return {
        key: keyName,
        text: decrypted,
        stringAlgorithm: stringAlgorithm,
    }
}

// export

module.exports = {
    VERSION: VERSION,
    NAME: NAME,

    StringAlgorithm: StringAlgorithm,
    StringAlgorithms: StringAlgorithms,

    encrypt: encrypt,
    decrypt: decrypt,

    encryptWithKeys: encryptWithKeys,
    decryptWithKeys: decryptWithKeys,
};